import { Browser } from '@capacitor/browser';
import {
  IonIcon,
  IonImg,
  IonLabel,
  IonPage,
} from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';

import DocumentIcon from '@/assets/imgs/document-icon.svg';
import DownloadIcon from '@/assets/imgs/download-icon.svg';
import { ROUTES_PATH } from '@/constants';
import ENVIRONMENT from '@/environments/environment';

import styles from './Documents.module.scss';

export default function Documents() {
  const history = useHistory();
  const { PROFILE } = ROUTES_PATH;

  const openTerms = () => {
    Browser.open({ url: ENVIRONMENT.URL_TERMS || 'https://peppercomercios.pepperfinance.es/terms-of-use' });
  };

  const openPrivacy = () => {
    Browser.open({ url: ENVIRONMENT.URL_PRIVACY_POLICY || 'https://peppercomercios.pepperfinance.es/privacy-policy' });
  };

  return (
    <IonPage>
      <div className={styles.pageTermsConditions}>
        <div className={styles.pageTermsConditionsHeader}>
          <IonIcon
            md={chevronBackOutline}
            className={styles.pageTermsConditionsTitleIcon}
            onClick={() => {
              history.push(PROFILE);
            }}
          />
          <IonLabel className={styles.pageTermsConditionsTitleInfo}>
            Términos y condiciones
          </IonLabel>
        </div>

        <div className={styles.pageProfileDocumentation}>
          <div className={styles.pageProfileDocumentationHeader}>
            <IonLabel className={styles.pageProfileDocumentationTitle}>
              Documentación
            </IonLabel>
            <IonLabel className={styles.pageProfileDocumentationSubtitle}>
              Todo lo que necesitas saber sobre nuestro servicio.
            </IonLabel>
          </div>
          <div className={styles.profileDocumentationContainer}>
            <IonImg className={styles.profileDocumentationIcon} src={DocumentIcon} />
            <div className={styles.profileDocumentationContainerText}>
              <p className={styles.profileDocumentationContainerTextTitle}>Términos de uso</p>
              <p className={styles.profileDocumentationContainerTextSubtitle}>(pdf, 1.2mb)</p>
            </div>
            <IonImg
              onClick={() => openTerms()}
              className={styles.profileDocumentationDownloadIcon}
              src={DownloadIcon}
            />
          </div>
          <div className={styles.profileDocumentationContainer}>
            <IonImg className={styles.profileDocumentationIcon} src={DocumentIcon} />
            <div className={styles.profileDocumentationContainerText}>
              <p className={styles.profileDocumentationContainerTextTitle}>Política privacidad</p>
              <p className={styles.profileDocumentationContainerTextSubtitle}>(pdf, 1.2mb)</p>
            </div>
            <IonImg
              onClick={() => openPrivacy()}
              className={styles.profileDocumentationDownloadIcon}
              src={DownloadIcon}
            />
          </div>
        </div>
      </div>
    </IonPage>
  );
}
